import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import socket from "../../socket";
import { endpoints } from "../../services/operations/api";
import { toast } from "react-hot-toast"; 
import "./EventDetails.css"; 

const EventDetails = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [attendeeCount, setAttendeeCount] = useState(0);
  const [isAttending, setIsAttending] = useState(false);
  const [isCreator, setIsCreator] = useState(false);




  const getFromLocalStorage = (key) => {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.error(`Error parsing ${key} from localStorage:`, error);
      return null;
    }
  };

  const user = getFromLocalStorage("user"); 
  const token = getFromLocalStorage("token"); 
  const userId = null;

  useEffect(() => {
 
    const fetchEvent = async () => {
      try {
        const response = await axios.get(
          endpoints.GET_EVENT_BY_ID_API(eventId)
        );
        if (response.data.success) {
          const eventData = response.data.event;


          setEvent(eventData);
          setAttendeeCount(eventData.attendeeCount);

       
          const userIsCreator = eventData.createdBy._id === userId;
          setIsCreator(userIsCreator);

       
          const userIsAttending = eventData.attendees.some(
            (attendeeId) => attendeeId === userId
          );
          setIsAttending(userIsAttending);
        }
      } catch (error) {
        toast.error("Failed to load event details! ❌");
        console.error("Error fetching event details:", error);
      }
    };

    fetchEvent();


    socket.emit("joinEvent", eventId);
    socket.on("attendeeCountUpdated", (newCount) => setAttendeeCount(newCount));

    return () => {

      socket.emit("leaveEvent", eventId);
      socket.off("attendeeCountUpdated");
    };
  }, [eventId, userId, user, token, navigate]);


  const handleJoinEvent = async () => {
    try {
      const response = await axios.post(
        endpoints.ATTEND_EVENT_API(eventId),
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setIsAttending(true);
        setAttendeeCount(response.data.attendeeCount);
        toast.success("🎉 You joined the event!");
      } else {
        toast.error(response.data.message || "Failed to join event.");
      }
    } catch (error) {
      toast.error("Error joining event ❌");
      console.error(
        "Error joining event:",
        error.response?.data?.message || error.message
      );
    }
  };


  const handleLeaveEvent = async () => {
    try {
      const response = await axios.post(
        endpoints.LEAVE_EVENT_API(eventId),
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setIsAttending(false);
        setAttendeeCount(response.data.attendeeCount);
        toast.success("🚪 You left the event!");
      } else {
        toast.error(response.data.message || "Failed to leave event.");
      }
    } catch (error) {
      toast.error("Error leaving event ❌");
      console.error(
        "Error leaving event:",
        error.response?.data?.message || error.message
      );
    }
  };


  const handleDeleteEvent = async () => {
    if (!window.confirm("Are you sure you want to delete this event?")) return;

    try {
      const response = await axios.delete(endpoints.DELETE_EVENT_API(eventId), {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        toast.success("🗑️ Event deleted successfully!");
        navigate("/dashboard");
      } else {
        toast.error(response.data.message || "Failed to delete event.");
      }
    } catch (error) {
      toast.error("Error deleting event ❌");
      console.error(
        "Error deleting event:",
        error.response?.data?.message || error.message
      );
    }
  };

  if (!event) return <p className="loading">Loading...</p>;

  const today = new Date(); 
  const todayDate = `${today.getFullYear()}-${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;

  const eventDateObj = new Date(event.date); 
  const eventDate = `${eventDateObj.getFullYear()}-${(
    eventDateObj.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${eventDateObj.getDate().toString().padStart(2, "0")}`;

  console.log("Today (Local):", todayDate);
  console.log("Event Date (Local):", eventDate);

  return (
    <div className="event-details">
      <div className="event-card">
        <h1 className="event-title">{event.name}</h1>
        <p className="event-description">{event.description}</p>
        <p className="event-date">
          📅 {new Date(event.date).toLocaleDateString()}
        </p>
        <p className="event-location">📍 {event.location}</p>
        <p className="event-attendees">
          👥 Attendees: {attendeeCount} / {event.maxAttendees}
        </p>


        <div className="event-status">
          {todayDate < eventDate ? (
      
            <p>
              📅 You can join this event on {eventDateObj.toLocaleDateString()}.
            </p>
          ) : todayDate === eventDate ? (
      
            !isAttending ? (
              <button className="join-button" onClick={handleJoinEvent}>
                Join Event
              </button>
            ) : (
              <button className="leave-button" onClick={handleLeaveEvent}>
                🚪 Leave Event
              </button>
            )
          ) : (
           
            <p>⚠️ This event is no longer available.</p>
          )}
        </div>

       
        {true && (
          <div className="event-actions">
            <button
              className="edit-button"
              onClick={() => navigate(`/update-event/${eventId}`)}
            >
              ✏️ Edit Event
            </button>
            <button className="delete-button" onClick={handleDeleteEvent}>
              🗑️ Delete Event
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventDetails;
